import React from 'react';

const SvgDots = props => (
  <svg
    id="dots_svg__Layer_1"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    {...props}
  >
    <defs>
      <style>{'.dots_svg__cls-1{fill:#000}'}</style>
    </defs>
    <g id="dots_svg__Group_171" data-name="Group 171">
      <circle
        id="dots_svg__Ellipse_24"
        data-name="Ellipse 24"
        className="dots_svg__cls-1"
        cx={12}
        cy={4.93}
        r={1.77}
      />
      <circle
        id="dots_svg__Ellipse_35"
        data-name="Ellipse 35"
        className="dots_svg__cls-1"
        cx={19.07}
        cy={4.93}
        r={1.77}
      />
      <circle
        id="dots_svg__Ellipse_32"
        data-name="Ellipse 32"
        className="dots_svg__cls-1"
        cx={4.93}
        cy={4.93}
        r={1.77}
      />
      <circle
        id="dots_svg__Ellipse_27"
        data-name="Ellipse 27"
        className="dots_svg__cls-1"
        cx={12}
        cy={12}
        r={1.77}
      />
      <circle
        id="dots_svg__Ellipse_36"
        data-name="Ellipse 36"
        className="dots_svg__cls-1"
        cx={19.07}
        cy={12}
        r={1.77}
      />
      <circle
        id="dots_svg__Ellipse_33"
        data-name="Ellipse 33"
        className="dots_svg__cls-1"
        cx={4.93}
        cy={12}
        r={1.77}
      />
      <circle
        id="dots_svg__Ellipse_28"
        data-name="Ellipse 28"
        className="dots_svg__cls-1"
        cx={12}
        cy={19.07}
        r={1.77}
      />
      <circle
        id="dots_svg__Ellipse_37"
        data-name="Ellipse 37"
        className="dots_svg__cls-1"
        cx={19.07}
        cy={19.07}
        r={1.77}
      />
      <circle
        id="dots_svg__Ellipse_34"
        data-name="Ellipse 34"
        className="dots_svg__cls-1"
        cx={4.93}
        cy={19.07}
        r={1.77}
      />
    </g>
  </svg>
);

export default SvgDots;
